import { Modal, Col, Row, Space, Typography, Dropdown, message } from "antd";
import EventsTypesFormDialog from "../components/EventsTypesFormDialog";
import { useState } from "react";
import { Guid } from "guid-typescript";
import EventsTypesView from "../components/EventsTypesView";
import { SearchQuery } from "../code/search-query/search-query";
import { getEventsTypesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { EventType } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function EventsTypesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [eventsTypesInputMode, setEventsTypesInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [eventsTypesInputOpen, setEventsTypesInputOpen] = useState(false);
  const [eventsTypesInputValues, setEventsTypesInputValues] =
    useState<EventType>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onEventTypeInputOpen(
    mode: "add" | "update" | "delete",
    values?: EventType,
  ): void {
    setEventsTypesInputMode(mode);
    setEventsTypesInputOpen(true);
    setEventsTypesInputValues(values || ({} as any));
  }

  function onEventTypeInputFinish(): void {
    setEventsTypesInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onEventTypeInputClose(): void {
    setEventsTypesInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading events-types export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getEventsTypesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Event Types
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("CalendarEventsTypes", "create")}

            className={`${!permissions.can("CalendarEventsTypes", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("CalendarEventsTypes", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onEventTypeInputOpen("add")}
          >
            Add Event Type
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <EventsTypesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onEventTypeInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <EventsTypesFormDialog
        mode={eventsTypesInputMode}
        open={eventsTypesInputOpen}
        initialValues={eventsTypesInputValues}
        onFinish={onEventTypeInputFinish}
        onCancel={onEventTypeInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default EventsTypesPage;
